import { render } from "./ServicesOverview.vue?vue&type=template&id=0498461c&scoped=true"
import script from "./ServicesOverview.vue?vue&type=script&lang=js"
export * from "./ServicesOverview.vue?vue&type=script&lang=js"

import "./ServicesOverview.vue?vue&type=style&index=0&id=0498461c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0498461c"]])

export default __exports__